import React from "react";
import "./Header.css";
import defaultuser from "../../../Images/user.png";
import { Link } from "react-router-dom";

// Context
import { useState, useContext } from "react";

import UserContext from "../../../Context/UserContext";
// End Context

function Header() {

  // Context
  const { userIN, setUserIN } = useContext(UserContext);
  // End Context

  return (
    <div className="comb-sec header-sec">
      <header className="header header-sticky p-0 mb-4XXX shadow-sm">
        <div className="container-fluid border-bottom px-4 header-inner-con">
          <h4 className="margin-unsetter">Field Force Automation (FFA)</h4>
          <ul className="header-nav ms-auto topbar-right-con">
            <li className="nav-item dropdown">
              {/* <a className="nav-link py-0 pe-0" data-coreui-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"> */}
              <div className="avatar avatar-md">
                <img className="avatar-img" src={defaultuser} alt="" />
              </div>
              {/* </a> */}
            </li>

            <li className="nav-item dropdown">
              {/* <a className="dropdown-item" href="#"> */}
              Admin 1{/* </a> */}
            </li>

            <li className="nav-item py-1">
              <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
            </li>

            <li className="nav-item dropdown">
              <Link to="/login" className="dropdown-item">
                Logout
              </Link>
              {/* <button onClick={() => setUserIN(false)}>
                Logout btn
              </button> */}
            </li>
          </ul>
        </div>
      </header>
    </div>
  );
}
export default Header;
